export enum AlertType {
    ACCOUNT_POSITION = 'accountPosition',
    MESSAGE_QUEUES = 'messageQueues',
    INTERFACE_INACTIVITY = 'interfaceInactivity',
    EVENT_INACTIVITY = 'eventInactivity',
    SYSTEM_ERROR_LOG = 'systemErrorLog',
    FAILED_INCOMING_INTERACTION = 'failedIncomingInteraction'
}
